// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/picker-view/style/index.less
// module id = 144
// module chunks = 0